import { createVueI18n } from '../locale';

export default createVueI18n((lang) => [
  require(`locales/simple_form/${lang}.yml`),
]);
